import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import { getFilterDropdownValuesService } from '../../services/organizationsService';
import filtersActionConstants from '../constants/filtersActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const setContactFilters = (filters) => async (dispatch) => {
  dispatch({ type: filtersActionConstants.SET_CONTACT_FILTERS, payload: filters });
};

export const resetContactFilters = () => async (dispatch) => {
  const filters = {
    referrals_sent: '',
    tags: [],
    sources: [],
    starred: false,
  };
  dispatch({ type: filtersActionConstants.SET_CONTACT_FILTERS, payload: filters });
};

export const resetDisputeFilters = () => async (dispatch) => {
  const filters = {
    statuses: [],
    openings: [],
    company_names: [],
    candidate_names: [],
    start_date: '',
    end_date: '',
    min_amount: '',
    max_amount: '',
    experiential_rewards: [],
  };
  dispatch({ type: filtersActionConstants.SET_DISPUTE_FILTERS, payload: filters });
};
export const setDisputeFilters = (filters) => async (dispatch) => {
  dispatch({ type: filtersActionConstants.SET_DISPUTE_FILTERS, payload: filters });
};

export const getFilterDropdownValues = (org_id) => async (dispatch) => {
  try {
    const response = await getFilterDropdownValuesService(org_id);

    if (response.data.response_code === responseCodes.OK) {
      dispatch({
        type: filtersActionConstants.SET_FILTER_DROPDOWN_VALUES,
        payload: response.data.payload,
      });
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    Notification.error(t('notifications.somethingWentWrong'));
  }
};
